import { get, merge } from 'es-toolkit/compat'

// Shared with direct-to-widget redirect sites that used to get this for free via /identity/login.
export function captureQueryParams(to) {
  const { $lendioCookies } = useNuxtApp()

  let queryObj = { ...to.query }
  const redirectUrl = get(queryObj, 'r')
  let isValidUrl = false

  try {
    const url = new URL(redirectUrl)
    isValidUrl = true
    console.error('Valid URL passed when expecting redirect only', { url })
  } catch (e) {
    // The catch flow is the expected path for users. No action needed, just continue
  }

  if (isValidUrl) {
    // We want to only allow relative redirects from this flow
    return { notFound: true }
  }

  let returnToPath = null

  // grab marketing params for touch if present in redirectUrl
  if (redirectUrl) {
    const decodedURL = decodeURI(redirectUrl)
    const redirectQuery = decodedURL.split('?')[1]
    const redirectQueryObj = redirectQuery
      ? redirectQuery.split('&').reduce((obj, val) => {
          let [key, value] = val.split('=')
          obj[key] = value
          return obj
        }, {})
      : {}
    queryObj = merge({}, redirectQueryObj, queryObj)
    returnToPath = parseInternalRedirect(redirectUrl)
    $lendioCookies.set('redirect', returnToPath, { maxAge: 60 * 10 })
  }

  // Set a cookie for each url query param
  setTrackingCookiesFromParams(queryObj)

  return { returnToPath }
}

export default defineNuxtRouteMiddleware(async (to) => {
  const { notFound } = captureQueryParams(to)
  if (notFound) {
    return navigateTo('/404')
  }
})
